module.exports = __webpack_public_path__ + "img/icon-app-btcpay.eda83eae.svg";